<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <div class="d-flex align-items-center flex-wrap gap-3 py-0">
              <div v-for="(image, i) in data.images" :key="i">
                <upload-image-direct
                  @inputChanged="uplodeImg_1($event, i)"
                  model="meals"
                  :data_src="data.images[i].image_preview"
                  placeHolder="صورة الوجبة"
                ></upload-image-direct>
                <!-- End:: Image -->
                <div
                  class="d-flex align-items-center justify-content-center gap-3"
                >
                  <button type="button" name="append" @click="appendImageRow">
                    <i class="fas fa-plus-circle"></i>
                  </button>

                  <button
                    v-if="i != 0"
                    type="button"
                    name="append"
                    @click="deleteImageRow(i, image.id)"
                  >
                    <i class="fas fa-minus-circle"></i>
                  </button>
                </div>
              </div>
              <v-btn
                v-if="!data.images.length"
                type="button"
                name="append"
                @click="appendImageRow"
              >
                <i class="fas fa-plus-circle"></i>
              </v-btn>
            </div>

            <div class="col-12"></div>
            <!-- Start:: Image -->

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.ar.name") }}*
                </label>
                <div class="custom-select">
                  <input
                    type="text"
                    v-model="data.ar.name"
                    @input="handleSearch1"
                    @keydown.enter.prevent="handleEnter1"
                    class="form-control"
                  />
                  <div
                    v-if="showDropdown1"
                    class="multiselect__content-wrapper"
                  >
                    <ul class="multiselect__content">
                      <li
                        v-for="(option, index) in filteredOptions1"
                        :key="index"
                        @click="selectOption1(option)"
                        class="multiselect__element"
                      >
                        <span class="multiselect__option">{{
                          option.name_ar
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.en.name") }}*
                </label>
                <div class="custom-select">
                  <input
                    type="text"
                    v-model="data.en.name"
                    @input="handleSearch2"
                    @keydown.enter.prevent="handleEnter2"
                    class="form-control"
                  />
                  <div
                    v-if="showDropdown2"
                    class="multiselect__content-wrapper"
                  >
                    <ul class="multiselect__content">
                      <li
                        v-for="(option, index) in filteredOptions2"
                        :key="index"
                        @click="selectOption2(option)"
                        class="multiselect__element"
                      >
                        <span class="multiselect__option">{{
                          option.name_en
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Start:: desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <textarea
                  type="text"
                  class="form-control"
                  v-model.trim="data.ar.desc"
                ></textarea>
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.ar.desc") }}*
                </label>
              </div>
            </div>
            <!-- End:: desc -->

            <!-- Start:: desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <textarea
                  type="text"
                  class="form-control"
                  v-model.trim="data.en.desc"
                ></textarea>
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.en.desc") }}*
                </label>
              </div>
            </div>
            <!-- End:: desc -->

            <!-- Start:: priority -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.priority"
                />
                <label for="name_input" class="form-label"> الاولوية </label>
              </div>
            </div>
            <!-- End:: priority -->

            <!-- Start:: price -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input type="text" class="form-control" v-model.trim="data.price" />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.price") }}*
                </label>
              </div>
            </div> -->
            <!-- End:: price -->

            <!-- Start:: menu -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.menu") }}*
                </label>
                <multiselect
                  :loading="menu_loading"
                  v-model="data.menu"
                  :options="menus"
                  label="name"
                  track-by="name"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <!-- End:: menu -->

            <!-- Start:: Name -->
            <div class="col-lg-12 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.calories"
                />

                <label for="name_input" class="form-label">
                  السعرات الحرارية
                </label>
              </div>
            </div>
            <!-- End:: Name -->

            <div class="border py-2 mb-5">
              <p>المقاسات</p>

              <div class="row" v-for="(size, i) in data.sizes" :key="i">
                <div class="input_wrapper top_label col-md ms-md-4 col-sm-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="data.sizes[i].ar.name"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.ar.name") }}*
                  </label>
                </div>

                <div class="input_wrapper top_label col-md ms-md-4 col-sm-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="data.sizes[i].en.name"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.en.name") }}*
                  </label>
                </div>

                <div class="input_wrapper top_label col-md col-sm-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="data.sizes[i].price"
                    pattern="[0-9]+([\.,][0-9]+)?"
                    step="0.01"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.price") }}*
                  </label>
                </div>

                <div class="col-md col-sm-4">
                  <div
                    class="d-flex align-items-center justify-content-center gap-2 h-100"
                  >
                    <button type="button" name="append" @click="appendSizeRow">
                      <i class="fas fa-plus-circle"></i>
                    </button>

                    <button
                      v-if="i != 0"
                      type="button"
                      name="append"
                      @click="deleteSizeRow(i, size.id)"
                    >
                      <i class="fas fa-minus-circle"></i>
                    </button>
                  </div>
                </div>
              </div>

              <v-btn
                v-if="!data.sizes.length"
                type="button"
                name="append"
                @click="appendSizeRow"
              >
                <i class="fas fa-plus-circle"></i>
              </v-btn>
            </div>

            <div class="py-2">
              <p>سكشن الاضافات</p>

              <div
                class=""
                v-for="(section, i) in data.additions_sections"
                :key="i"
              >
                <div class="row">
                  <div class="col-md-12">
                    <span>سكشن {{ i + 1 }}</span>
                  </div>
                  <div class="col-md-11">
                    <div class="border">
                      <div class="row">
                        <div
                          class="input_wrapper top_label col-md-4 ms-md-5 col-sm-5"
                        >
                          <input
                            type="text"
                            class="form-control"
                            v-model.trim="section.ar.name"
                          />
                          <label for="name_input" class="form-label">
                            {{ $t("forms.labels.ar.name") }}*
                          </label>
                        </div>
                        <div
                          class="input_wrapper top_label col-md-4 ms-md-5 col-sm-5"
                        >
                          <input
                            type="text"
                            class="form-control"
                            v-model.trim="section.en.name"
                          />
                          <label for="name_input" class="form-label">
                            {{ $t("forms.labels.en.name") }}*
                          </label>
                        </div>
                        <div class="col-md col-sm">
                          <v-checkbox
                            :label="$t('forms.labels.required')"
                            v-model="section.required"
                            color="#783D73"
                          ></v-checkbox>
                        </div>
                        <div
                          class="input_wrapper top_label col-md-4 ms-md-5 col-sm-5"
                        >
                          <input
                            type="number"
                            class="form-control"
                            v-model.trim="section.min"
                          />
                          <label for="name_input" class="form-label">
                            {{ $t("forms.labels.min") }}*
                          </label>
                        </div>
                        <div
                          class="input_wrapper top_label col-md-4 ms-md-5 col-sm-5"
                        >
                          <input
                            type="number"
                            class="form-control"
                            v-model.trim="section.max"
                            @change="enforceSectionConstraints(section)"
                          />
                          <label for="name_input" class="form-label">
                            {{ $t("forms.labels.max") }}*
                          </label>
                        </div>
                      </div>
                      <div class="border py-2 px-2 mr-4 ml-4 mb-5">
                        <p>الاضافات</p>

                        <div
                          class="row"
                          v-for="(addition, i2) in section.additions"
                          :key="i2"
                        >
                          <div
                            class="input_wrapper top_label col-md ms-md-4 col-sm-4"
                          >
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="addition.ar.name"
                            />
                            <label for="name_input" class="form-label">
                              {{ $t("forms.labels.ar.name") }}*
                            </label>
                          </div>
                          <div
                            class="input_wrapper top_label col-md ms-md-4 col-sm-4"
                          >
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="addition.en.name"
                            />
                            <label for="name_input" class="form-label">
                              {{ $t("forms.labels.en.name") }}*
                            </label>
                          </div>

                          <div class="input_wrapper top_label col-md col-sm-4">
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="addition.price"
                              pattern="[0-9]+([\.,][0-9]+)?"
                              step="0.01"
                            />
                            <label for="name_input" class="form-label">
                              {{ $t("forms.labels.price") }}*
                            </label>
                          </div>

                          <div class="col-md col-sm-4">
                            <div
                              class="d-flex align-items-center justify-content-center gap-2 h-100"
                            >
                              <button
                                type="button"
                                name="append"
                                @click="appendAdditionRow(i)"
                              >
                                <i class="fas fa-plus-circle"></i>
                              </button>

                              <button
                                v-if="i2 != 0"
                                type="button"
                                name="append"
                                @click="deleteAdditionRow(i, i2, addition.id)"
                              >
                                <i class="fas fa-minus-circle"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <v-btn
                          v-if="!section.additions.length"
                          type="button"
                          name="append"
                          @click="appendAdditionRow(i)"
                        >
                          <i class="fas fa-plus-circle"></i>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="d-flex align-items-center justify-content-center gap-2 h-100"
                    >
                      <button
                        type="button"
                        name="append"
                        @click="appendAdditionSectionRow"
                      >
                        <i class="fas fa-plus-circle"></i>
                      </button>

                      <button
                        v-if="i != 0"
                        type="button"
                        name="append"
                        @click="deleteAdditionSectionRow(i, section.id)"
                      >
                        <i class="fas fa-minus-circle"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <v-btn
                  v-if="!data.additions_sections.length"
                  type="button"
                  name="append"
                  @click="appendAdditionSectionRow"
                >
                  <i class="fas fa-plus-circle"></i>
                </v-btn>
              </div>

              <!-- Start:: Is Active -->
              <div class="col-12 py-2">
                <v-checkbox
                  :label="$t('forms.labels.is_active')"
                  v-model="data.is_active"
                  color="#783D73"
                ></v-checkbox>
              </div>
            </div>

            <!-- Start:: placeCategory -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.placeCategory") }}*
                </label>
                <multiselect
                  :loading="!placeCategories.length"
                  v-model="data.placeCategory"
                  :options="placeCategories"
                  label="name"
                  track-by="name"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  @input="getPlace(data.placeCategory.id)"
                ></multiselect>
              </div>
            </div> -->
            <!-- End:: placeCategory -->

            <!-- Start:: place -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> {{ $t("forms.labels.places") }}* </label>
                <multiselect
                  :disabled="!places.length"
                  v-model="data.place"
                  :options="places"
                  label="name"
                  track-by="name"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div> -->
            <!-- End:: place -->

            <!-- Start:: Is Active -->
            <!-- <div class="col-12 py-2">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="#783D73"
              ></v-checkbox>
            </div> -->
            <!-- End:: Is Active -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      searchQuery: "",
      showDropdown1: false,
      showDropdown2: false,
      mealsFetchTimer: null,
      meal1: null,
      meal2: null,
      allMeals: [], // Will be populated with categories from API
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.googlePlace.title"),
          disabled: false,
          href: "/googlePlace/show-all",
        },
        {
          text: this.$t("breadcrumb.meals.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      menu_loading: false,
      // ========== Data To Send
      data: {
        images: [
          {
            id: 100000,
            avatar: null,
            image_preview: null,
          },
        ],
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        priority: null,
        // price: null,
        menu: null,
        place: null,
        calories: null,
        placeCategory: null,
        sizes: [
          {
            id: 100000,
            ar: {
              name: null,
            },
            en: {
              name: null,
            },
            price: null,
          },
        ],
        additions_sections: [
          {
            id: Math.random()
              .toString(36)
              .replace(/[^a-z]+/g, "")
              .substr(0, 5),
            ar: {
              name: null,
            },
            en: {
              name: null,
            },
            required: false,
            min: null,
            max: null,
            additions: [
              {
                id: Math.random()
                  .toString(36)
                  .replace(/[^a-z]+/g, "")
                  .substr(0, 5),
                ar: {
                  name: null,
                },
                en: {
                  name: null,
                },
                price: null,
              },
            ],
          },
        ],
        password: null,
        password_confirmation: null,
        is_active: true,
      },

      // ========== Fixed Data
      menus: [],
      placeCategories: [],
      places: [],
    };
  },

  computed: {
    filteredOptions1() {
      if (!this.data.ar.name || this.data.ar.name.trim().length < 2) return [];
      return this.allMeals.filter((option) =>
        option.name_ar.toLowerCase().includes(this.data.ar.name.toLowerCase())
      );
    },
    filteredOptions2() {
      if (!this.data.en.name || this.data.en.name.trim().length < 2) return [];
      return this.allMeals.filter((option) =>
        option.name_en.toLowerCase().includes(this.data.en.name.toLowerCase())
      );
    },
  },

  methods: {
    fetchMealsDebounced(query) {
      if (this.mealsFetchTimer) {
        clearTimeout(this.mealsFetchTimer);
      }
      this.mealsFetchTimer = setTimeout(() => {
        this.getMeals(query);
      }, 300);
    },
    // Add a new tag (category) when not found in the list
    handleSearch1() {
      const length = (this.data.ar.name || "").trim().length;
      this.showDropdown1 = length >= 2;
      // If the search query is empty, clear the selection
      if (length < 2) {
        this.meal1 = null;
        this.showDropdown1 = false;
        if (this.mealsFetchTimer) clearTimeout(this.mealsFetchTimer);
      } else {
        this.fetchMealsDebounced((this.data.ar.name || "").trim());
      }
    },

    handleEnter1() {
      if (!this.data.ar.name || this.data.ar.name.trim().length < 2) {
        this.showDropdown1 = false;
        return;
      }
      // If there are filtered options, select the first one
      if (this.filteredOptions1.length > 0) {
        this.selectOption1(this.filteredOptions1[0]);
      } else if (this.data.ar.name.trim() !== "") {
        // If no match, set the search query as the value
        this.meal1 = this.data.ar.name.trim();
      }
      this.showDropdown1 = false;
    },

    selectOption1(option) {
      // Update the search query for display
      this.data.ar.name = option.name_ar;
      this.showDropdown1 = false;
      // Set the v-model to the matched object
      this.meal1 = option;
      this.data.en.name = option.name_en;
      this.data.ar.desc = option.desc_ar;
      this.data.en.desc = option.desc_en;
    },

    handleClickOutside1(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown1 = false;
      }
    },

    // Add a new tag (category) when not found in the list
    handleSearch2() {
      const length = (this.data.en.name || "").trim().length;
      this.showDropdown2 = length >= 2;
      // If the search query is empty, clear the selection
      if (length < 2) {
        this.meal2 = null;
        this.showDropdown2 = false;
        if (this.mealsFetchTimer) clearTimeout(this.mealsFetchTimer);
      } else {
        this.fetchMealsDebounced((this.data.en.name || "").trim());
      }
    },

    handleEnter2() {
      if (!this.data.en.name || this.data.en.name.trim().length < 2) {
        this.showDropdown2 = false;
        return;
      }
      // If there are filtered options, select the first one
      if (this.filteredOptions2.length > 0) {
        this.selectOption2(this.filteredOptions2[0]);
      } else if (this.data.en.name.trim() !== "") {
        // If no match, set the search query as the value
        this.meal2 = this.data.en.name.trim();
      }
      this.showDropdown2 = false;
    },

    selectOption2(option) {
      // Update the search query for display
      this.data.en.name = option.name_en;
      this.showDropdown2 = false;
      // Set the v-model to the matched object
      this.meal2 = option;
      this.data.ar.name = option.name_ar;
      this.data.ar.desc = option.desc_ar;
      this.data.en.desc = option.desc_en;
    },

    handleClickOutside2(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown2 = false;
      }
    },
    async getMeals(query) {
      this.$axios({
        method: "GET",
        url: `meal_name_not_paginated`,
        params: {
          search: query,
        },
      })
        .then((res) => {
          this.allMeals = res.data.data.map((item) => {
            return {
              id: item.id,
              name_ar: `${item.ar.name}`,
              name_en: `${item.en.name}`,
              desc_ar: `${item.ar.desc}`,
              desc_en: `${item.en.desc}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    appendImageRow() {
      this.data.images.push({
        id: this.data.images.length + 100000,
        avatar: null,
        image_preview: null,
      });
    },
    deleteImageRow(i, id) {
      if (id.toString().length <= 5) {
        this.$axios({
          method: "delete",
          url: `google_meals/image/${id}`,
        })
          .then(() => {
            this.data.images.splice(i, 1);

            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
          })
          .catch((err) => {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.images.splice(i, 1);
      }
    },
    appendSizeRow() {
      this.data.sizes.push({
        id: this.data.sizes.length + 100000,
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        price: null,
      });
    },
    deleteSizeRow(i, id) {
      if (id.toString().length <= 5) {
        this.$axios({
          method: "delete",
          url: `google_meals/size/${id}`,
        })
          .then(() => {
            this.data.sizes.splice(i, 1);

            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
          })
          .catch((err) => {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.sizes.splice(i, 1);
      }
    },
    appendAdditionSectionRow() {
      this.data.additions_sections.push({
        id: this.data.additions_sections.length + 100000,
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        required: false,
        min: null,
        max: null,
        additions: [
          {
            id: Math.random()
              .toString(36)
              .replace(/[^a-z]+/g, "")
              .substr(0, 5),
            ar: {
              name: null,
            },
            en: {
              name: null,
            },
            price: null,
          },
        ],
      });
    },
    deleteAdditionSectionRow(i, id) {
      if (id.toString().length <= 5) {
        this.$axios({
          method: "delete",
          url: `google_meals/addition_section/${id}`,
        })
          .then(() => {
            this.data.additions_sections.splice(i, 1);

            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
          })
          .catch((err) => {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.additions_sections.splice(i, 1);
      }
    },
    appendAdditionRow(sectionIndex) {
      this.data.additions_sections[sectionIndex].additions.push({
        id:
          this.data.additions_sections[sectionIndex].additions.length + 100000,
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        price: null,
      });
    },
    deleteAdditionRow(sectionIndex, i, id) {
      if (id.toString().length <= 5) {
        this.$axios({
          method: "delete",
          url: `google_meals/addition/${id}`,
        })
          .then(() => {
            this.data.additions_sections[sectionIndex].additions.splice(i, 1);

            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
          })
          .catch((err) => {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });

        console.log(id);
      } else {
        this.data.additions_sections[sectionIndex].additions.splice(i, 1);
        console.log(id);
      }
    },
    // ============ Get Select Lists Data
    async getMenus() {
      this.menu_loading = true;
      this.$axios({
        method: "GET",
        url: `menu_not_paginated`,
        params: {
          place_category_id: this.$route.params.place_id,
        },
      })
        .then((res) => {
          this.menus = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
          this.menu_loading = false;
        })
        .catch((error) => {
          this.menu_loading = false;
          console.log(error.response.data.message);
        });
    },

    async getPlace_PlaceCategory() {
      this.$axios({
        method: "GET",
        url: `show_place/${this.$route.params.id}`,
      })
        .then((res) => {
          this.data.place = res.data.place;
          this.data.placeCategory = res.data.place.place_categeory_id;
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },

    // Uplode Image
    uplodeImg_1(obj, i) {
      this.data.images[i].avatar = obj;
    },

    enforceSectionConstraints(section) {
      const sectionsCount = Array.isArray(section.additions)
        ? section.additions.length
        : 0;

      if (section.required) {
        let proposedMin = section.min;
        if (proposedMin == null || proposedMin < 1) proposedMin = 1;
        section.min = proposedMin;

        if (section.min > sectionsCount && sectionsCount > 0) {
          section.min = sectionsCount;
        }
      } else {
        section.min = section.min === 0 || section.min === "0" ? 0 : null;
      }
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      }

      // Validate Sections
      for (let i = 0; i < this.data.additions_sections.length; i++) {
        const section = this.data.additions_sections[i];

        const hasSectionData =
          section.ar.name || section.en.name || section.min || section.max;
        const hasAdditionsData = section.additions.some(
          (add) => add.ar.name || add.en.name || add.price
        );
        const isFilled = hasSectionData || hasAdditionsData || section.required;

        if (isFilled) {
          if (
            !section.ar.name ||
            !section.en.name ||
            section.min === null ||
            section.min === "" ||
            section.max === null ||
            section.max === ""
          ) {
            this.$iziToast.error({
              timeout: 2000,
              message: `يرجى إكمال جميع الحقول المطلوبة في سكشن الإضافات رقم ${
                i + 1
              }`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          }

          if (section.required && section.min < 1) {
            this.$iziToast.error({
              timeout: 2000,
              message: `يجب أن يكون الحد الأدنى 1 على الأقل في السكشن المطلوب رقم ${
                i + 1
              }`,
              position: "bottomRight",
            });
            this.btnIsLoading = false;
            return;
          }

          for (let j = 0; j < section.additions.length; j++) {
            const add = section.additions[j];
            if (
              !add.ar.name ||
              !add.en.name ||
              add.price === null ||
              add.price === ""
            ) {
              this.$iziToast.error({
                timeout: 2000,
                message: `يرجى إكمال جميع الحقول المطلوبة في الإضافة رقم ${
                  j + 1
                } داخل سكشن ${i + 1}`,
                position: "bottomRight",
              });
              this.btnIsLoading = false;
              return;
            }
          }
        }
      }

      this.submitData();
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.images.length > 0) {
        this.data.images.map((el, i) => {
          if (el.avatar) {
            submit_data.append(`images[${i}]`, el.avatar);
          }
        });
      }

      this.data.sizes.map((el, i) => {
        if (el.ar.name) {
          submit_data.append(`sizes[${i}][ar][name]`, el.ar.name);
        }
        if (el.en.name) {
          submit_data.append(`sizes[${i}][en][name]`, el.en.name);
        }
        if (el.price > 0) {
          submit_data.append(`sizes[${i}][price]`, el.price);
        } else if (el.price == 0) {
          submit_data.append(`sizes[${i}][price]`, 0);
        }
      });

      const validSections = this.data.additions_sections.filter((section) => {
        const hasSectionData =
          section.ar.name || section.en.name || section.min || section.max;
        const hasAdditionsData = section.additions.some(
          (add) => add.ar.name || add.en.name || add.price
        );
        return hasSectionData || hasAdditionsData || section.required;
      });

      if (validSections.length > 0) {
        validSections.map((el, i) => {
          if (el.en.name) {
            submit_data.append(`sections[${i}][en][name]`, el.en.name);
          }
          if (el.ar.name) {
            submit_data.append(`sections[${i}][ar][name]`, el.ar.name);
          }
          if (el.ar.name || el.en.name) {
            submit_data.append(`sections[${i}][is_required]`, +el.required);
          }
          if (el.required) {
            if (el.min > 0) {
              submit_data.append(`sections[${i}][minimum_choices]`, el.min);
            } else if (el.min == 0) {
              submit_data.append(`sections[${i}][minimum_choices]`, 0);
            }
            if (el.max) {
              submit_data.append(`sections[${i}][maximum_choices]`, el.max);
            }
          } else {
            if (el.min > 0) {
              submit_data.append(`sections[${i}][minimum_choices]`, 0);
            } else if (el.min == 0) {
              submit_data.append(`sections[${i}][minimum_choices]`, 0);
            }
            if (el.max) {
              submit_data.append(`sections[${i}][maximum_choices]`, el.max);
            }
          }
          if (el.additions.length > 0) {
            el.additions.map((addition, j) => {
              if (addition.en.name) {
                submit_data.append(
                  `sections[${i}][additions][${j}][en][name]`,
                  addition.en.name
                );
              }
              if (addition.ar.name) {
                submit_data.append(
                  `sections[${i}][additions][${j}][ar][name]`,
                  addition.ar.name
                );
              }
              if (addition.price > 0) {
                submit_data.append(
                  `sections[${i}][additions][${j}][price]`,
                  addition.price
                );
              } else if (addition.price == 0) {
                submit_data.append(`sections[${i}][additions][${j}][price]`, 0);
              }
            });
          }
        });
      }

      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("en[name]", this.data.en.name);
      if (this.data.ar.desc != null) {
        submit_data.append("ar[desc]", this.data.ar.desc);
      }
      if (this.data.en.desc != null) {
        submit_data.append("en[desc]", this.data.en.desc);
      }
      // submit_data.append("price", this.data.price);
      if (this.data.priority) {
        submit_data.append("priority", this.data.priority);
      }
      if (this.data.menu?.id) {
        submit_data.append("menu_id", this.data.menu?.id);
      }
      if (this.$route.params.id) {
        submit_data.append("place_id", this.$route.params.id);
      }
      if (this.data.calories) {
        submit_data.append("calories", this.data.calories);
      }
      // submit_data.append("place_categeory_id", this.data.placeCategory);

      submit_data.append("is_active", +this.data.is_active);
      // submit_data.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `google_meals`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({
            path: `/googlePlace/show_google_place/${this.$route.params.id}?page=meals`,
          });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // Empty Form Data
    emptyFormData() {
      this.name = null;
    },
  },

  watch: {
    "data.additions_sections": {
      handler(newSections) {
        if (!Array.isArray(newSections)) return;
        newSections.forEach((section) => {
          this.enforceSectionConstraints(section);
        });
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    // Start:: Fire Methods
    this.getMenus();
    // this.getPlace_PlaceCategory();
    // this.getRegions();
    // End:: Fire Methods
  },
};
</script>
